// Ce que dit la source en cas d'oubli, mot pour mot, avec sa source et sa date.
// L'appli affiche ; elle ne calcule ni ne décide rien (05, « Règles d'oubli »).
import { useTranslation } from 'react-i18next';

import type { Regle } from '../lib/api';
import { dateComplete } from '../lib/format';

/** Source, date et état de relecture. Les notes de travail (`aVerifier`, version de
 *  la table) restent dans la table : elles ne s'affichent pas (#14). */
export function SourceRegle({ regle }: Readonly<{ regle: Regle }>) {
  const { t } = useTranslation();
  const s = regle.source;
  return (
    <div className="text-secondaire mt-4 space-y-2 text-sm leading-relaxed">
      <p>
        {t('oubli.source')} {s.editeur}, {s.titre}
        {s.pages ? `, ${t('oubli.pages', { pages: s.pages })}` : ''} ({s.dates}).{' '}
        <a href={s.url} className="underline underline-offset-4" rel="noreferrer" target="_blank">
          {t('oubli.lireSource')}
        </a>
        . {t('oubli.consulte', { date: dateComplete(s.consulteLe) })}
      </p>
      {!regle.relu && <p>{t('oubli.nonRelu')}</p>}
    </div>
  );
}

export function TexteOubli({ regle, renvoi }: Readonly<{ regle: Regle; renvoi: string }>) {
  const { t } = useTranslation();
  const [tete, ...points] = regle.apresLeDelai;
  return (
    <section aria-labelledby="oubli-titre" className="border-alerte mt-8 border-l-2 pl-4">
      <h2 id="oubli-titre" className="text-lg font-semibold">
        {t('oubli.titre')}
      </h2>
      <p className="text-texte-long mt-3 leading-relaxed">{tete}</p>
      {points.length > 0 && (
        <ul className="text-texte-long mt-3 list-disc space-y-2 pl-5 leading-relaxed">
          {points.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      )}
      <p className="mt-4 font-medium">{renvoi}</p>
      <SourceRegle regle={regle} />
    </section>
  );
}
